/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { decrypt } from "utils/crypto";
import Icon from "uis/Icon";
import { theme } from "styles/theme";
import { TVisitPurpose } from "apis/visitors/type";
import { useRecoilValue } from "recoil";
import { userInfo, workspace } from "recoil/recoilState";

const Frame = styled.div`
  width: 450px;
  min-height: 670px;
  background-color: white;
  border-radius: 20px;
  border: 10px solid black;
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px;
`;

const Logo = styled.div<{ logo?: string }>`
  background-color: ${theme.neutral50};
  background-image: ${(props) => (props.logo ? `url(${props.logo})` : "")};
  background-size: contain;
  background-repeat: no-repeat;
  border-radius: 10px;
  width: 30px;
  height: 30px;
`;

const Welcome = styled.p`
  font-weight: 400;
  font-size: 24px;
  line-height: 120%;
  margin-top: 20px;
  padding: 0 24px;
`;

const Card = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  background-color: ${theme.neutral50};
  border-radius: 10px;
  padding: 30px 0;
  align-items: center;
`;

const CardLabel = styled.p`
  color: ${theme.neutral900};
  font-size: 16px;
  font-weight: 600;
`;

const CardIcon = styled.div<{ image?: string }>`
  background-image: url(${(props) => props.image});
  width: 32px;
  height: 32px;
  background-size: contain;
  background-repeat: no-repeat;
`;

export default function PurposePreview({ purposes }: { purposes?: TVisitPurpose[] }) {
  const workspaceInfo = useRecoilValue(workspace);
  return (
    <Frame>
      <Header>
        <Icon name="left-arrow" />
        <p
          css={css`
            font-weight: 700;
            font-size: 16px;
          `}
        >
          당일 방문
        </p>
        <Logo logo={workspaceInfo?.image} />
      </Header>
      <Welcome>
        안녕하세요
        <br />
        <strong>어떤 용무</strong>로 방문하셨나요?
      </Welcome>
      <div
        css={css`
          display: grid;
          grid-template-columns: 1fr 1fr 1fr;
          row-gap: 12px;
          column-gap: 12px;
          padding: 30px 24px;
        `}
      >
        {purposes?.map((item, index) => {
          return (
            <Card key={index}>
              <CardIcon image={item.image} />
              <CardLabel>{item.content}</CardLabel>
            </Card>
          );
        })}
      </div>
    </Frame>
  );
}
